import { Box , Chip} from '@material-ui/core'
import AmsChip from '../../atoms/AmsChip/AmsChip'
import { useState, useEffect } from 'react'
import deletionIcon from "../../assets/image/deleteAddon.png"
import { useContextSelector } from '@fluentui/react-context-selector';
import { StoreContext } from "../../context";
import actionTypeConstants from "../../utils/actionTypeConstants";
import "./amsroomlist.css"

const AmsRoomsList = (props:any) => {
    const { rooms,roomPresent } = props
    const [roomList, setRoomList] = useState<any>(rooms || [])
    const [selectedRooms, setSelectedRooms] = useState<any[]>(roomPresent || [])

    const dispatch: any = useContextSelector(
        StoreContext,
        (store) => store?.dispatch
    )
    useEffect(() => {
        let roomArr = [...rooms];
        let presentRoom = [...roomPresent];
        setSelectedRooms(presentRoom)
        setRoomList(roomArr)
    },[rooms,roomPresent])

    useEffect(() => {
         dispatch({
            type: actionTypeConstants.CUSTOMER_JOURNEY,
            payload: {
                "rooms" : selectedRooms
            },
        })

        if(selectedRooms.length >0){
            sessionStorage.setItem('selectedRooms', JSON.stringify(selectedRooms));
        }

       
    },[selectedRooms])

    useEffect(() => {
        
        let selectedRooms:any = sessionStorage.getItem('selectedRooms');
        selectedRooms = JSON.parse(selectedRooms);
        if(selectedRooms?.length>0){
            const remainingProducts = rooms.filter((itemTwo:any) => !selectedRooms.some((itemOne:any) => itemOne.index === itemTwo.index));
            //console.log("Here I am  : ",roomInfo,list,remainingProducts)
            setRoomList(remainingProducts)
            setSelectedRooms(selectedRooms)
        }
    },[])

    const SelectedRoomChip = ({text,index}:any) =>{
        return(
            <Box className='roomCountItem'>
                <Chip label={`${text}`} className='productChip' />
                <Box className='increment' onClick={() => handleRoomDeletion(index)}><img src={deletionIcon} width={25}/></Box>
            </Box>
        )
    }

    const handleRoomClick = (index:number) => {
        let listArr = [...roomList]
        let room = listArr.filter((item)=> item?.index === index)[0]
        room['select'] = true;
        listArr = listArr.filter((item)=> item?.index !== index)
        setRoomList([...listArr])
        setSelectedRooms(selectedRoom => [...selectedRoom,room]);
    }

    const handleRoomDeletion = (index:any) => {
        let listArr = [...selectedRooms]
        let room = listArr.filter((item)=> item?.index === index)[0]
        let remainingSelectedRoom = listArr.filter((item)=> item?.index !== index)
        let inventory:any = sessionStorage.getItem("inventory")
        let roomInfo:any = sessionStorage.getItem("roomInfo");
        if(inventory){
            inventory = JSON.parse(inventory);
            roomInfo = JSON.parse(roomInfo)
            console.log("Inventory is : ",inventory, room)

            let newInventory = inventory?.filter((entry:any) => entry.room !== room.room);

            //const roomToUpdate = roomInfo.find((item:any) => Object.keys(item)[0] === room.room);

            // if (roomToUpdate) {
            //     const itemsToUpdate = roomToUpdate[room?.room];
            //     itemsToUpdate.forEach((item:any) => {
            //         item.quantity = 0;
            //     });
            // }

            for (const item of roomInfo) {
                if (item[room?.room]) {
                    for (const singleRoom of item[room?.room]) {
                        singleRoom.quantity = 0;
                    }
                    break; // Assuming each room is unique, stop iterating once the room is found
                }
            }

            console.log("New Inventory is : ",newInventory,roomInfo)
            
            sessionStorage.setItem("inventory", JSON.stringify( newInventory))
            sessionStorage.setItem("roomInfo", JSON.stringify(roomInfo))
        }
        setRoomList((prevRoomList:any) => [...prevRoomList,room]); 
        setSelectedRooms([...remainingSelectedRoom])


    }

    return (
        <Box className='productList'>
             <Box  mb={5} mt={5} className="listItems">
                {roomList.length > 0 && roomList?.map((item:any, index:any) => {
                    return (
                        <AmsChip className="singleProduct" itemClick={()=>handleRoomClick(item?.index)} text={item?.text} key={index}/>
                    )
                }) }
               
            </Box>

            <Box mb={5} mt={5} className="room">
                {selectedRooms?.map((item:any, index:any) => {
                    return (
                        <SelectedRoomChip text={item?.text} index={item?.index} className="singleRoom"/>
                    )
                }) }
               
            </Box>
        </Box>
    )
}

export default AmsRoomsList